import { ordersQuery } from "@/api/queries";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { payment?: "success" | "cancelled"; session_id?: string } => ({
    payment: search.payment as "success" | "cancelled" | undefined,
    session_id:
      typeof search.session_id === "string" ? search.session_id : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!context.auth.authenticated) {
      throw redirect({ to: "/" });
    }
    // Staff land in the admin portal, not the customer dashboard.
    if (context.auth.roles.includes("echorai-admin")) {
      throw redirect({ to: "/admin" });
    }
  },
  loader: ({ context }) => context.queryClient.ensureQueryData(ordersQuery()),
});
